import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/lib/Api'

Vue.use(Vuex)

const files = require.context('./modules', false, /\.js$/);

let SOCKET_IO_URL;
let OFFICIAL_SOCKET_IO_URL;

const modules = files.keys().reduce((acc, key) => {
    const name = key.replace(/(\.\/|\.js)/g, '')
    const module = files(key).default

    acc[name] = module

    return acc
}, {})

export default new Vuex.Store({
    modules,
    state: {
        currentUser: null,
        breadcrumbs: [],
        drawerMenuItems: [],
        pageTitle: 'InteligênciaBot',
        pageSubtitle: '',
        pageLoading: false,
        SOCKET_IO_URL: undefined,
        OFFICIAL_SOCKET_IO_URL: undefined,
        credits: 0,
        dialog: {
            show: false,
            title: '',
            message: '',
            resolve: null
        },
    },
    mutations: {
        setCurrentUser(state, payload) {
            state.currentUser = payload
        },
        setCredits(state, payload) {
            state.credits = payload
        },
        setBreadcrumbs(state, payload) {
            state.breadcrumbs = payload
        },
        setDrawerMenuItems(state, payload) {
            state.drawerMenuItems = payload
        },
        setPageTitle(state, payload) {
            state.pageTitle = payload

            document.title = payload || 'InteligênciaBot'
        },
        setPageSubtitle(state, payload) {
            state.pageSubtitle = payload
        },
        setPageLoading(state, payload) {
            state.pageLoading = payload
        },
        setDialog(state, payload) {
            state.dialog = payload
        },
        setSocketIOURL(state, payload) {
            state.SOCKET_IO_URL = process.env.NODE_ENV === "development" ? "http://localhost:5001" : `https://${payload}.inteligenciabot.com.br/`;
            //state.SOCKET_IO_URL = `https://${payload}.inteligenciabot.com.br/`;
        },
        setOfficialSocketIOURL(state, payload) {
            state.OFFICIAL_SOCKET_IO_URL = process.env.NODE_ENV === "development" ? "http://localhost:5002" : `https://${payload}.inteligenciabot.com.br/`;
            //state.SOCKET_IO_URL = `https://${payload}.inteligenciabot.com.br/`;
        },
    },
    actions: {
        async loadCurrentUser({ commit }) {
            const user = await Api.getRemoteUser();
            if (!SOCKET_IO_URL && user.account && user.account.server) commit('setSocketIOURL', user.account.server);
            if (!OFFICIAL_SOCKET_IO_URL && user.account && user.account.official_api_server) commit('setOfficialSocketIOURL', user.account.official_api_server);
            commit('setCurrentUser', user);
        },

        async confirmDialog({ commit }, payload) {
            return new Promise((resolve) => {
                commit('setDialog', {
                    show: true,
                    title: payload?.title || 'Confirmar ação',
                    message: payload?.message || 'Você tem certeza que deseja realizar esta ação?',
                    resolve
                })
            })
        }
    },
})